import { action } from 'easy-peasy';
import { IActionSetMedicaidHistory } from '../types';

const setMedicaidHistory: IActionSetMedicaidHistory = action((state, payload) => {
  state.medicaidHistory = payload;
});

export default setMedicaidHistory;
